module.exports = __webpack_public_path__ + "static/media/bg.991851f5.jpg";